import { ResponseStatuses } from '../api/utils'

export interface ApiError {
    key: string
    messages: string[]
}

export class HttpRequestError extends Error {
    status: number

    constructor(status: number) {
        super()
        this.status = status
    }
}

export class BadRequestError extends HttpRequestError {
    errors?: ApiError[]
    constructor(errors?: ApiError[]) {
        super(ResponseStatuses.BadRequest)
        this.errors = errors
    }
}

export class AuthenticationError extends HttpRequestError {
    constructor() {
        super(ResponseStatuses.Unauthorized)
    }
}
